module.exports = __webpack_public_path__ + "static/img/ic_default_three.5a7d697.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic_default_three.png
// module id = pXe1
// module chunks = 0